import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

function Habits() {
  const navigate = useNavigate();
  const [habit, setHabit] = useState("");
  const [habits, setHabits] = useState([]);

  const addHabit = () => {
    if (!habit.trim()) return;
    setHabits([...habits, { text: habit, completed: false }]);
    setHabit("");
  };

  const toggleHabit = (index) => {
    const updated = [...habits];
    updated[index].completed = !updated[index].completed;
    setHabits(updated);
  };

  const deleteHabit = (index) => {
    setHabits(habits.filter((_, i) => i !== index));
  };

  return (
    <div className="page">
      <h1>My Habits</h1>

      <div style={{ marginBottom: "15px" }}>
        <input
          type="text"
          value={habit}
          onChange={(e) => setHabit(e.target.value)}
          placeholder="Enter habit"
        />
        <button onClick={addHabit}>Add</button>
      </div>

      <ul>
        {habits.map((h, index) => (
          <li key={index} className={h.completed ? "completed" : ""}>
            <span>{h.text}</span>

            <div className="actions">
              <button
                className="tick-btn"
                onClick={() => toggleHabit(index)}
              >
                ✔
              </button>

              <button
                className="delete-btn"
                onClick={() => deleteHabit(index)}
              >
                ✖
              </button>
            </div>
          </li>
        ))}
      </ul>

      <button
        className="back-btn"
        onClick={() => navigate("/")}
      >
        ← Back
      </button>
    </div>
  );
}

export default Habits;
